import { RootState } from 'src/app/store'

export const selectPipeline = (state: RootState) => state.pipeline
